export default "__VITE_ASSET__9d8a3bb9__"